import * as React from 'react'
import StationUserInfo from '../../../containers/station-user/StationUserInfo'
import StationUserGoinZonePane from '../../../containers/station-user/StationUserGoinZonePane'
import { Route, RouteComponentProps, Switch } from 'react-router'
import { IMap, IStationUserSearchObject, IZoneObject } from 'src/types'
import StationUserInfoHeader from './StationUserInfoHeader'
import StationUserPaneHeader from './StationUserPaneHeader'
import UIMessages from 'src/utils/ui-messages'
import { handleRedirect } from 'src/utils'
import EntityHeaderTitle from 'src/components/ui/entity/EntityHeaderTitle'

export interface IStationUserViewPaneProps {
  notification?: any
  routeProps: RouteComponentProps<any>
  stationUser: IStationUserSearchObject
  stationUserId: string
  zones: IMap<IZoneObject>
  fetchStationUser: () => void
  onArchiveClick: (stationUser: IStationUserSearchObject) => Promise<void>
}

interface IStationUserViewPane {
  isSelect: boolean
  loading: boolean
  activeTab: string
}

class StationUserViewPane extends React.Component<
  IStationUserViewPaneProps & RouteComponentProps<any>,
  IStationUserViewPane
> {
  constructor(props: IStationUserViewPaneProps & RouteComponentProps<any>) {
    super(props)

    this.state = {
      isSelect: true,
      loading: false,
      activeTab: UIMessages.stationUser.userInfo
    }
  }

  public componentDidMount() {
    const { fetchStationUser } = this.props
    fetchStationUser()
    const { pathname } = window.location
    if (pathname.includes('zones')) {
      this.setState({ activeTab: UIMessages.stationUser.goinZones })
    }
  }

  public componentWillUnmount() {
    this.setState({ isSelect: true })
  }

  public render() {
    const { routeProps, stationUser } = this.props
    const { loading, activeTab } = this.state
    const {
      common: { edit },
      stationUser: { stationUser: stationUserLabel }
    } = UIMessages
    const { pathname } = window.location
    const isEdit = pathname.includes('edit')

    return (
      <div>
        {isEdit && (
          <div className='p2'>
            <EntityHeaderTitle>{`${edit} ${stationUserLabel}`}</EntityHeaderTitle>
          </div>
        )}
        {!isEdit && stationUser && (
          <StationUserInfoHeader
            activeTab={activeTab}
            isArchived={stationUser.isArchived}
            loading={loading}
            name={stationUser.name}
            stationUser={stationUser}
            status={stationUser.status}
            onMoveToArchive={this.onMoveToArchive}
          />
        )}
        <StationUserPaneHeader
          activeTab={activeTab}
          handleChangeTab={tab => {
            this.setState({ activeTab: tab })
            const path = this.getPath(tab)
            handleRedirect(path)
          }}
        />
        <Switch>
          <Route path={`${routeProps.match.path}/zones/edit`} render={this.editRenderZones} />
          <Route path={`${routeProps.match.path}/zones`} render={this.renderZones} />
          <Route path={`${routeProps.match.path}`} render={this.renderMainInfo} />
        </Switch>
      </div>
    )
  }

  private renderMainInfo = (props: RouteComponentProps<any>) => (
    <StationUserInfo {...props} stationUser={this.props.stationUser} />
  )

  private renderZones = (props: RouteComponentProps<any>) => {
    if (!this.props.stationUserId) {
      return null
    }
    return <StationUserGoinZonePane serviceId={this.props.stationUserId} {...props} viewMode={true} />
  }

  private editRenderZones = (props: RouteComponentProps<any>) => {
    if (!this.props.stationUserId) {
      return null
    }
    const showMessage = (msg: string) => {
      console.log('showing message: ', msg)
    }
    return (
      <StationUserGoinZonePane
        serviceId={this.props.stationUserId}
        {...props}
        showMessage={showMessage}
        viewMode={false}
      />
    )
  }

  private setIsSelect1 = () => {
    this.setState({ isSelect: true })
  }
  private setIsSelect2 = () => {
    this.setState({ isSelect: false })
  }

  private onMoveToArchive = () => {
    this.setState({ loading: true }, () => {
      if (!this.props.stationUser) {
        return
      }
      this.props
        .onArchiveClick(this.props.stationUser)
        .then(() => {
          this.props.fetchStationUser()
        })
        .catch((error: unknown) => {
          console.error(error)
        })
        .finally(() => this.setState({ loading: false }))
    })
  }

  private getPath = (tab: string) => {
    const { pathname } = window.location
    const { stationUser } = this.props
    const isEdit = pathname.includes('edit')
    const path =
      tab === UIMessages.stationUser.userInfo
        ? isEdit
          ? `/station-user/edit/${stationUser.id}`
          : `/station-user/${stationUser.id}`
        : isEdit
        ? `/station-user/edit/${stationUser.id}/zones/edit`
        : `/station-user/${stationUser.id}/zones`
    return path
  }
}

export default StationUserViewPane



// WEBPACK FOOTER //
// ./src/components/station-user/view/StationUserViewPane.tsx